// Anonymous-friendly chrome for /decks/:owner/:slug viewed signed-out.
// (PR2 / PUBLIC-DECKS plan, §5.5.)
//
// Slim top bar: brand on the left, "Sign up" CTA on the right. No
// sidebar nav, no balance widget, no command palette — those are
// authed-app conveniences a public viewer shouldn't be teased with.
// The page outlet renders inside a centered container that mirrors
// AuthedApp's main column width so the deck reads identically below
// the fold.
//
// Signed-in viewers don't pass through here — App.tsx routes them
// through AuthedApp which has the full sidebar.

import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { SignInButton, SignUpButton } from "@clerk/clerk-react";

export default function PublicShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-bg-base text-fg flex flex-col">
      <header className="border-b border-border bg-bg-surface/40 backdrop-blur">
        <div className="mx-auto max-w-6xl px-6 py-3 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5">
            <img
              src="/logo.svg"
              alt="MTG Oracle"
              width={24}
              height={24}
              aria-hidden="true"
            />
            <span className="font-semibold tracking-tight text-sm">
              MTG Oracle
            </span>
            <span className="ml-1 font-mono text-[10px] uppercase tracking-widest text-fg-subtle hidden sm:inline">
              Beta
            </span>
          </Link>
          <nav className="flex items-center gap-1">
            <SignInButton mode="modal">
              <button type="button" className="btn-ghost text-xs">
                Sign in
              </button>
            </SignInButton>
            <SignUpButton mode="modal">
              <button type="button" className="btn-primary text-xs">
                Sign up
              </button>
            </SignUpButton>
          </nav>
        </div>
      </header>
      <main className="flex-1">{children}</main>
    </div>
  );
}
